import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import axios from '@/axios'
import api from '@/utils/api';
import {str_slug} from '@/utils/helpers'

import adminManagement from './admin-management';
import campaignManagement from './campaign-management';
import contentManagement from './content-management';
import setting from './setting';
import product from './product-management';
import chat from './chat';
import brandAmbassador from './brand-ambassador';
import withdraw from './withdraw';
import productClaim from './product-claim';
import requestUnsuspend from './request-unsuspend';
import notification from './notification';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('@/layouts/main/Main.vue'),
            meta: {
              auth: true
            },
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'dashboard',
                component: () => import('@/views/Dashboard.vue'),
                meta: {
                  link: 'dashboard',
                  breadcrumb: [
                      { title: 'Dashboard', active: true }
                  ],
                  pageTitle: 'Dashboard'
                }
              },
              {
                path: '/profile',
                name: 'profile-page',
                component: () => import('@/views/pages/Profile.vue'),
                meta: {
                  breadcrumb: [
                      { title: 'Profile', active: true }
                  ],
                  pageTitle: 'Profile'
                }
              },
              product,
              brandAmbassador,
              withdraw,
              productClaim,
              chat,
              ...adminManagement,
              ...campaignManagement,
              ...contentManagement,
              ...setting,
              requestUnsuspend,
              notification
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            meta: {
              guest: true
            },
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/recover',
                name: 'page-recover-password',
                component: () => import('@/views/pages/RecoverPassword.vue')
              },
              {
                path: '/reset-password',
                name: 'page-reset-password',
                component: () => import('@/views/pages/ResetPassword.vue')
              },

            ]
          },
        {
          path: '/privacy-policy',
          name: 'page-privacy-policy',
          component: () => import('@/views/pages/PrivacyPolicy.vue')
        },
        {
          path: '/500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue')
        },
        {
          path: '*',
          name: 'page404',
          component: () => import('@/views/pages/Error404.vue')
        },
    ],
})

router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }

  const pagination = JSON.parse(sessionStorage.getItem('db_currentPage'))
  const paginationCB = JSON.parse(sessionStorage.getItem('campaign_ba_pagination'))
  if(pagination && !window.location.pathname.includes(pagination.route)) {
    sessionStorage.removeItem('db_currentPage')
  }
  if(paginationCB && (to.name !== 'detailcampaign' && to.name !== 'detailbrand')) {
    sessionStorage.removeItem('campaign_ba_pagination')
  }
})

const getProfile = () => {
  return axios.get(api.me)
  .then(resp => {
      const data = resp.data.data;
      store.dispatch('updateUserInfo', data);
  })
}

const checkUserPermission = (userMenu = [], to, next) => {
  let menus = []
  userMenu.forEach(menu => {
      if(menu.submenu) {
          let submenu = menu.submenu
          submenu.forEach(child => {
              menus.push(str_slug(child.name.toLowerCase()))
          })
      } else {
          menus.push(str_slug(menu.name.toLowerCase()))
      }
  })

   if (to.matched.some(record => record.meta.link)) {
        const {link} = to.meta
        if(link) {
            menus.includes(link.toLowerCase()) ? next() : next('/404')
        } else {
            next()
        }
    } else {
        next()
    }
}

router.beforeEach((to, from, next) => {
  /* auth middleware */
  if (to.matched.some(record => record.meta.auth)) {
      if (!localStorage.getItem('token')) {
          next('/login');
      } else {
        let userMenu = store.state.menus
        if(userMenu.length === 0) {
          getProfile()
          .then(() => {
            if(store.state.platforms.length < 1 ) {
              // get misc platforms
              store.dispatch('getListPlatform')
            }
          })
          .then(() => {
            checkUserPermission(store.state.menus, to, next)
          })
          .catch( () => {
            store.dispatch('logout')
            next('/login')
          })
        } else {
          checkUserPermission(userMenu, to, next)
        }
      }
  } else if(to.matched.some(record => record.meta.guest)){
      if (localStorage.getItem('token')) {
          next('/');
      } else {
          next()
      }
  } else {
      next();
  }
});

export default router
